import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import GridList from 'src/Components/GridList';
import DepartmentCard from '../DepartmentCard';

import { EmptyView } from './EmptyView';

export default class MyDepartments extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => {},
  };

  handleClick = (id, index, data) => {
    this.props.onClick(id, index, data);

    // TODO: set state for exam score form??
  };

  renderItem = (data, index) => {
    const { variant, onSelectDeparmentId } = this.props;
    return (
      <DepartmentCard depId={data.id} variant={variant} onSelectDeparmentId={onSelectDeparmentId} />
    );
  };

  render() {
    const { data } = this.props;
    return (
      <Fragment>
        <GridList
          columns={1}
          data={data}
          renderItem={this.renderItem}
          onClick={this.handleClick}
          as="div"
          flexProps={{
            alignItems: 'center',
          }}
          emptyView={EmptyView}
        />
      </Fragment>
    );
  }
}
